import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ICommitOrderResult } from "./types";
import {
  ftthOrchestrator,
  mobileOrchestrator,
  changeMsisdnOrchestrator,
  multiOrderOrchestrator,
  changeSimEsimOrchestrator,
  verificationErrorResponse,
} from "./validators";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { BasicError, err } from "@nju/result";

interface IParams {
  orchestratorId: string;
  consent: Array<{
    consentId: string;
    consentVersion: number;
  }>;
  mode: IOfferMode | "changeMsisdn" | "changeSimEsim" | "multiOrder";
}

const modeToOrchestratorMap = {
  ftth: ftthOrchestrator,
  mobile: mobileOrchestrator,
  changeMsisdn: changeMsisdnOrchestrator,
  changeSimEsim: changeSimEsimOrchestrator,
  multiOrder: multiOrderOrchestrator,
} as const;

export async function commitOrder({
  orchestratorId,
  consent,
  mode,
}: IParams): Promise<ICommitOrderResult> {
  const serverResponse = modeToOrchestratorMap[mode];
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/ORDER_COMMIT`,
    {
      method: "post",
      validator: serverResponse,
      json: {
        consent,
      },
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    }
  );

  if (result.isError) {
    const errorInfo = verificationErrorResponse.safeParse(
      result.err.extra?.json
    );

    if (errorInfo.success) {
      if (errorInfo.data.code === "50255") {
        return err(
          new BasicError({
            message: "negative PESEL validation",
            code: "PESEL_NEGATIVE",
          })
        );
      }

      if (errorInfo.data.code === "50254") {
        return err(
          new BasicError({
            message: "GOV API unavailable or some error returned from GOV",
            code: "PESEL_GOV_UNAVAILABLE",
          })
        );
      }
    }

    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
